import React, { useState, useEffect } from 'react';
import Header from '../../../Components/Dashboard/Header/Header';
import Sidebar from '../../../Components/Dashboard/Sidebar/Sidebar';
import './UserReport.css';
import { BiHomeAlt } from 'react-icons/bi';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { Apiurl, GetToken } from '../../../Utils/utils';
import axios from 'axios';
import Loader from '../../../Components/loader/loader';

const UserReport = () => {
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [leaveData, setLeaveData] = useState(null);
  const [showSidebar, setShowSidebar] = useState(true);
  const [allEmployeeData, setAllEmployeeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateError, setDateError] = useState("");

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => setShowSidebar(false), 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const validateDates = (start, end) => {
    if ((start && !end) || (!start && end)) {
      setDateError("Both Start Date and End Date must be provided together.");
      return false;
    }
    if (start && end && new Date(start) > new Date(end)) {
      setDateError("Start Date cannot be greater than End Date.");
      return false;
    }
    setDateError("");
    return true;
  };

  const handleSelect = (e) => {
    const userId = e.target.value;
    setSelectedEmployee(userId);
    setLeaveData(null);
  };

  const handleSearch = () => {
    if (!selectedEmployee) {
      setDateError("Please select an employee first.");
      return;
    }
    if (!validateDates(startDate, endDate)) return;
    GetUserLeaveReport(selectedEmployee, startDate, endDate);
  };

  const handleReset = () => {
    setSelectedEmployee('');
    setLeaveData(null);
    setStartDate('');
    setEndDate('');
    setDateError('');
  };

  const GetAllEmployee = () => {
    setLoading(true);
    const token = GetToken();
    axios({
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${Apiurl()}/Admin/GetAllEmployees`,
    })
      .then((e) => {
        setLoading(false);
        setAllEmployeeData(JSON.parse(e?.data?.data));
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    GetAllEmployee();
  }, []);

  const GetUserLeaveReport = (userId, start, end) => {
    setLoading(true);
    const token = GetToken();

    const payload = {
      UserId: userId,
      ...(start && end && {
        StartDate: new Date(start).toISOString(),
        EndDate: new Date(end).toISOString(),
      }),
    };

    axios({
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${Apiurl()}/Leave/GetUserLeaveReport`,
      data: { data: JSON.stringify(payload) },
    })
      .then((res) => {
        setLoading(false);
        if (res?.data?.success) {
          setLeaveData(JSON.parse(res?.data?.data));
        } else {
          setLeaveData(null);
          setDateError(res?.data?.message || "No data found.");
        }
      })
      .catch(() => {
        setLoading(false);
        setLeaveData(null);
      });
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <div className={showSidebar ? "main-container-of-all-employees-page" : "main-container-of-all-employees-page-new"}>
          <div className="inner-container-of-all-userreport-page">
            <div className="header-of-employees-page row">
              <div className="all-employee-text col"><h4>User Report</h4></div>
              <div className="all-employees-directory col">
                <BiHomeAlt />
                <MdKeyboardArrowRight />
                <p>Admin</p>
                <MdKeyboardArrowRight />
                <p>User Report</p>
              </div>
            </div>
          </div>

          <div className="body-part-outer-container">
            <div className="inner-body-container-of-userreport-table">
              <div className="user-report-card">

                <h2>User Leave Report</h2>

                {/* CONTROLS */}
                <div className="user-report-card-controls">

                  {/* Employee */}
                  <div className="user-report-field">
                    <label>Employee</label>
                    <select
                      value={selectedEmployee}
                      onChange={handleSelect}
                    >
                      <option value="">Select Employee</option>
                      {allEmployeeData.map((emp) => (
                        <option key={emp.UserId} value={emp.UserId}>
                          {emp.FirstName} {emp.LastName}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Start Date */}
                  <div className="user-report-field">
                    <label>Start Date</label>
                    <input
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      max={endDate || undefined}
                    />
                  </div>

                  {/* End Date */}
                  <div className="user-report-field">
                    <label>End Date</label>
                    <input
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      min={startDate || undefined}
                    />
                  </div>

                  <button className="user-report-search-btn" onClick={handleSearch}>
                    Search
                  </button>

                  <button className="user-report-reset-btn" onClick={handleReset}>
                    Reset
                  </button>
                </div>

                {dateError && <div className="user-report-date-error">{dateError}</div>}

                {leaveData ? (
                  <table className="user-report-table">
                    <thead>
                      <tr>
                        <th>Three Quarter</th>
                        <th>Short</th>
                        <th>Half Day</th>
                        <th>Casual</th>
                        <th>Official</th>
                        <th>Sick</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{leaveData?.ThreeQuarterLeave ?? 0}</td>
                        <td>{leaveData?.ShortLeave ?? 0}</td>
                        <td>{leaveData?.HalfDayleave ?? 0}</td>
                        <td>{leaveData?.CasualLeave ?? 0}</td>
                        <td>{leaveData?.OfficialLeave ?? 0}</td>
                        <td>{leaveData?.SickLeave ?? 0}</td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  !dateError && <p className="user-report-no-data">Select an employee to view leave data.</p>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserReport;